import type { StaticImageData } from 'next/image';

// This normalizes image imports between Next.js and Vite
export function imageImportSrc(image: string | StaticImageData) {
  return typeof image === 'string' ? image : image.src;
}
